import { render, staticRenderFns } from "./JcomTableMembersCreate.vue?vue&type=template&id=6110fba6"
import script from "./JcomTableMembersCreate.vue?vue&type=script&lang=js"
export * from "./JcomTableMembersCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports